<template>
  <div id="EditCustomerForm">
    <!-- Form Updated IMEI  -->
    <form v-if="fieldToUpdate === 'imei'" action>
      <div class="modal-card fixed-width dtac-font">
        <!-- Modal Title -->
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t("form.imei.title") }}</p>
        </header>
        <!-- Modal Description + Input -->
        <section class="modal-card-body">
          <div class="media">
            <div class="media-content">
              <!-- Modal Description -->
              <p class="subtitle is-6" style="line-height: 1.75;">
                {{ $t("form.imei.current_imei") }}: <b>{{ oldValue }}</b> <br />
                {{ $t("form.imei.description") }}
              </p>
              <!-- Modal Input Field -->
              <b-field>
                <b-input
                  required
                  type="number"
                  v-model="newValue"
                  custom-class="dtac-font"
                  :placeholder="$t('form.imei.placeholder')"
                />
              </b-field>
            </div>
          </div>
        </section>
        <!-- Modal Footer -->
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <!-- Button: Close -->
          <button class="button dtac-font" @click.prevent="$emit('close')">
            {{ $t("register.form.otp.close_btn") }}
          </button>
          <!-- Button: Save -->
          <button
            class="button is-primary dtac-font"
            @click.prevent="saveButtonPressed"
          >
            {{ $t("register.form.otp.confirm_btn") }}
          </button>
        </footer>
      </div>
    </form>
    <!-- Form Updated Lock Distance  -->
    <form v-else-if="fieldToUpdate === 'distance'" action>
      <div class="modal-card fixed-width dtac-font">
        <!-- Modal Title -->
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t("form.distance.title") }}</p>
        </header>
        <!-- Modal Description + Input -->
        <section class="modal-card-body">
          <div class="media">
            <div class="media-content">
              <!-- Modal Description -->
              <p class="subtitle is-6" style="line-height: 1.75;">
                {{ $t("form.distance.current_distance") }}
                <b
                  >{{ oldValue | todecimal(2) }} {{ $t("form.distance.unit") }}
                </b>
                <br />{{ $t("form.distance.description") }}
              </p>

              <!-- Modal Input Field -->
              <b-field>
                <b-input
                  required
                  type="number"
                  v-model="newValue"
                  custom-class="dtac-font"
                  :placeholder="$t('form.distance.placeholder')"
                />
              </b-field>
            </div>
          </div>
        </section>
        <!-- Modal Footer -->
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <!-- Button: Close -->
          <button class="button dtac-font" @click.prevent="$emit('close')">
            {{ $t("register.form.otp.close_btn") }}
          </button>
          <!-- Button: Save -->
          <button
            class="button is-primary dtac-font"
            @click.prevent="saveButtonPressed"
          >
            {{ $t("register.form.otp.confirm_btn") }}
          </button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import AlertManager from "@/managers/AlertManager";
import CustomerApiManager from "@/apis/CustomerApiManager";

export default {
  name: "EditCustomerForm",
  props: ["field", "value"],
  data() {
    return {
      fieldToUpdate: this.field,
      oldValue: this.value,
      newValue: null,
      isDisableSave: true
    };
  },
  filters: {
    todecimal: function(value, decimal_place) {
      if (!value) return "";
      return Number(value).toFixed(decimal_place);
    }
  },
  methods: {
    saveButtonPressed: function() {
      if (this.newValue && this.newValue !== "") {
        let params = {
          cust_id: this.$route.params.id
        };
        switch (this.fieldToUpdate) {
          case "imei":
            params.imei = this.newValue;
            this.updateImei(params);
            break;
          case "distance":
            params.lock_distance = this.newValue;
            this.updateLockDistance(params);
            break;
          default:
            AlertManager.showErrorSnackbar("Wrong field to update");
            break;
        }
      } else {
        AlertManager.showErrorSnackbar("Please fill a new value in the field");
      }
    },
    updateImei: async function(updateImeiParams) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const updateImeiResult = await CustomerApiManager.requestUpdateImei(
        updateImeiParams
      );
      loadingComponent.close();

      switch (updateImeiResult.code) {
        case "0":
          AlertManager.showSuccessSnackbar("Updated IMEI Successfully");
          this.$emit("update_customer_detail");
          break;

        default:
          AlertManager.showErrorSnackbar(updateImeiResult.message);
          break;
      }
      this.$emit("close");
    },
    updateLockDistance: async function(updateDistanceParams) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const updateDistanceResult = await CustomerApiManager.requestUpdateLockDistance(
        updateDistanceParams
      );
      loadingComponent.close();
      switch (updateDistanceResult.code) {
        case "0":
          AlertManager.showSuccessSnackbar(
            "Updated Lock Distance Successfully"
          );
          this.$emit("update_customer_detail");
          break;

        default:
          AlertManager.showErrorSnackbar(updateDistanceResult.message);
          break;
      }
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.fixed-width {
  max-width: 480px;
  padding: 0 20px;
}
</style>
